import {Box, Grid, GridItem} from '@panda/jsx';
import {ProductDisclaimerFieldsFragment} from '@common/hygraph-schema';
import {Alert} from '../alert';
import {AgeRating} from './AgeRating.organism';

export const ProductDisclaimer = (props: ProductDisclaimerFieldsFragment) => {
	return (
		<Grid
			gap="4"
			gridTemplateColumns={{
				base: '1fr',
				sm: '3fr 1fr'
			}}>
			<GridItem>
				<Box bg="eds.color.neutral.150" borderRadius="eds.borderRadius.16" h="100%">
					<Alert {...props.disclaimer} />
				</Box>
			</GridItem>
			<GridItem minW="328px">
				<AgeRating />
			</GridItem>
		</Grid>
	);
};
